module.exports = __webpack_public_path__ + "1792395595471/images/doc.52186d4.svg";